export const KEY = 'VGwq6keS6XDm1Wu3FbTVZWvmHRsbFSFe'



// WEBPACK FOOTER //
// ./src/constants/key.js